
export const paths = {
    currentTime: "/currentTime",
    options: "whoo/options",
    optionArray: "/optionArray",
    optionSortMap: "/sortMap",
    header: "/whoo/header",
    /** Index slug -> {ownerId, pollId} fuer Sample Polls (admin-published). */
    samplePollSlugs: "/whoo/samplePollSlugs",
    votes: "whoo/votes",
    /**
     * Kontaktfelder der Votes (userEmail, userPhone, privateComment) unter
     * {ownerId}/{pollId}/{voterId} — per Rules nur fuer Poll-Owner (+Delegates)
     * und den Voter selbst lesbar, waehrend whoo/votes public bleibt.
     */
    votePrivate: "whoo/votePrivate",
    /**
     * Oeffentliche Per-Option-Aggregate {ownerId}/{pollId}/{optionIndex} ->
     * {positiveCount, personsSum}, gepflegt vom votesCounter-Trigger (Admin SDK,
     * Rules: read true / write false). Grundlage der Limit-Pruefung fuer
     * Teilnehmer, die bei showParticipants=false die Vote-Liste nicht lesen
     * duerfen. KEIN totalVotes hier — die Gesamt-Anzahl bleibt allein
     * header/votesCounter (analysis-option-counts-2026-08-31).
     */
    voteCounts: "whoo/voteCounts",
    participation: "whoo/participation",
    images: "images",
    emails: {
        unsubscribe: "/unsubscribe",
        toBeProcessed: "/emails/toBeProcessed",
        processed: "/emails/processed",
        unsubscribed: "/emails/unsubscribed",
        error: "/emails/error",
        /**
         * Tagesaggregate {YYYY-MM-DD} -> {processed, errors, retried}. Bleiben dauerhaft
         * stehen — sie sind alles, was von der Fehler-Historie uebrig bleibt, sobald die
         * Retention die Mail-Bodies geloescht hat.
         */
        stats: "/emails/stats",
        /**
         * Zustand des Retry-Laeufers: {circuitOpenRuns} — aufeinanderfolgende Runs,
         * in denen der Circuit-Breaker offen war. Functions-owned (Admin SDK), kein
         * Client-Zugriff.
         */
        runnerState: "/emails/runnerState",
    },
    /**
     * Tagesaggregate {YYYY-MM-DD} -> {accessLinkProcessed, accessLinkErrors,
     * feedbackProcessed, feedbackErrors}. Gegenstueck zu /emails/stats fuer die
     * beiden Notification-Queues, seit die Retention auch deren Buckets raeumt.
     */
    notificationStats: "/notifications/stats",
    accessLinkNotification: {
        toBeProcessed: "/notifications/accessLinkNotification/toBeProcessed",
        processed: "/notifications/accessLinkNotification/processed",
        error: "/notifications/accessLinkNotification/error",
    },
    feedbackNotification: {
        toBeProcessed: "/notifications/feedback/toBeProcessed",
        processed: "/notifications/feedback/processed",
        error: "/notifications/feedback/error",
    },
    /**
     * Rate-Limit-Marker der Private-Comment-Sofortmail:
     * {ownerId}/{pollId}/{voterId} -> {lastSentAt, lastCommentHash, dayKey, dayCount}.
     * Functions-owned (Admin SDK) — kein Client-Zugriff (database.rules.json).
     */
    privateCommentMail: "/notifications/privateCommentMail",
    /**
     * Rate-Limit-Marker der Vote-Bestaetigungs-Mail an Teilnehmer:
     * {ownerId}/{pollId}/{voterId} -> {lastSentAt, lastVoteHash, dayKey, dayCount}.
     * Functions-owned (Admin SDK) — kein Client-Zugriff (database.rules.json).
     */
    voteConfirmationMail: "/notifications/voteConfirmationMail",
    notificationsQueue: "notificationsQueue",
    /**
     * Fehlgeschlagene Vote-Notifications: {yyyy-mm-dd-hh}/{recipientUid}/{pushId}.
     * Datums-Buckets statt flacher Push-IDs — die Namen sortieren aber ebenfalls
     * chronologisch, deshalb funktionieren Digest-Fenster und Retention-Cutoff hier
     * ueber denselben orderByKey()-Mechanismus.
     */
    notificationsQueueError: "notificationsQueue/error",
    /**
     * Flat auto-close index {ownerId}-{pollId} -> {ownerId, pollId, deadlineMs,
     * reminderNotifiedAt?, closedNotifiedAt?}. Maintained by the
     * whocan-maintainAutoCloseIndex trigger, queried by whocan-processPollDeadlines.
     * Functions-owned (Admin SDK) — clients have no access: /whoo/notPublic has no
     * client rules, and /whoo grants .read per public child node, not at the root.
     */
    autoClose: "/whoo/notPublic/autoClose",
    users: "/users",
    feedback: "user-feedback",
    paymments: "/shop/payments",
    activeProducts: "shop/activeProducts", // the active products assgined to the user
    deactivatedProducts: "shop/deactivatedProducts",
    functions: {
        paypalStart: 'shop-paypalStart',
        paypalProcess: 'shop-paypalProcess',
    }
};

export const storagePaths = {
    users: "users",
    images: "images"
}

